import React from 'react';
import {
  Card,
  FormInstance,
  Row,
  Tabs,
  Form,
  DatePicker,
  Modal,
  Input,
  Col,
  Button,
} from 'antd';
import FormItem from 'antd/lib/form/FormItem';
import FormInput from 'components/FormInput';
import InputCurrency from 'components/InputCurrency';
import InputRate from 'components/InputRate';
import ParListSelect from 'components/ParListSelect';
import RateFormulaSelect from 'components/RateFormulaSelect';
import TaxSelect from 'components/TaxSelect';
import Title from 'components/Title';
import Value from 'components/Value';
import GetLabel from 'DisplayFramework/components/GetLabel';
import Text from 'antd/lib/typography/Text';
import { toCurrency, toRate } from 'utils/utils';
import { shouldUpdateCompare } from 'utils/utils2';
import SliderWithInputAndPercentage from 'components/SliderWithInputAndPercentage';
import SliderWithInput from 'components/SliderWithInput';
import FinancialScheduleModal from 'components/FinancialScheduleModal';
import ScheduleButton from 'components/ScheduleButton';
import DataGrid from 'components/DataGrid';
import NewButtonSmall from 'components/NewButtonSmall';
import { CalculatorTwoTone } from '@ant-design/icons';
import moment from 'moment';
import ModalControllerNV from 'components/ModalControllerNV';
import PayementModal from 'pages/Payment/PayementModal';

const { TabPane } = Tabs;

export type AdvancedModeModalProps = {
  visible?: boolean;
  onClose?: any;
  form: FormInstance;
  preFin?: boolean;
  cteid?: number;
};
const AdvancedModeModal = (props: AdvancedModeModalProps) => {
  const { visible = false, onClose, form, preFin, cteid } = props;
  const handleratespread = (rateval: any, rateof: string) => {
    let FinElements = form.getFieldValue(['elements', 'FIN']);
    if (rateof === 'prefin')
      FinElements[0].prefinnominalrate =
        FinElements[0].prefinrateref + Number(rateval);
    if (rateof === 'cte')
      FinElements[0].ctenominalrate =
        FinElements[0].cterateref + Number(rateval);
    form.setFieldsValue({
      elements: {
        FIN: FinElements,
      },
    });
  };
  const handleselectformula = (rateval: number, rateof: string) => {
    let FinElements = form.getFieldValue(['elements', 'FIN']);
    if (rateof === 'prefin') FinElements[0].prefinrateref = rateval;
    if (rateof === 'cte') FinElements[0].cterateref = rateval;

    form.setFieldsValue({
      elements: {
        FIN: FinElements,
      },
    });
  };
  const getName = (param: string, cteid: any) => {
    if (cteid === 0) {
      return ['elements', 'FIN', 0, param];
    } else {
      const index = form
        .getFieldValue(['elements', 'FIN'])
        .findIndex((item: any) => item.cteid === cteid);
      return ['elements', 'FIN', index, param];
    }
  };

  const getHelper = (param: string, cteid: any) => {
    if (cteid === 0) {
      return ['elements', 'FIN', 0, 'helpers', param];
    } else {
      const index = form
        .getFieldValue(['elements', 'FIN'])
        .findIndex((item: any) => item.cteid === cteid);
      return ['elements', 'FIN', index, 'helpers', param];
    }
  };
  return (
    (<Modal
      open={visible}
      title="AdvancedMode"
      onCancel={() => {
        onClose();
      }}
      width="1500px"
      style={{ top: 20 }}
      footer={null}
      destroyOnClose
    >
      <Card
        extra={
          <FinancialScheduleModal
            currcode={form.getFieldValue('currcode')}
            finElement={form
              .getFieldValue(['elements', 'FIN'])
              ?.find(
                (ele: any) =>
                  ele.cteid === form.getFieldValue('selectedElement')
              )}
            comcode="finSchedule"
            controller={
              <ScheduleButton
                size="large"
                comcode="finSchedule"
                twoToneColor="blue"
              ></ScheduleButton>
            }
          />
        }
      >
        <Tabs animated tabPosition="top" defaultActiveKey="21">
          <TabPane tab={<GetLabel label="tabGeneralData" />} key={21}>
            <Card
              bordered
              title={<Title level={4} comcode="CalculationMethod"></Title>}
            >
              <Row gutter={20}>
                <Form.Item shouldUpdate={() => true} noStyle>
                  <FormInput
                    col
                    lg={6}
                    name={getName('ctecategory', cteid)}
                    comcode="ctecategory"
                  >
                    <ParListSelect parcode="CTEFIN" />
                  </FormInput>
                </Form.Item>

                <Form.Item shouldUpdate={() => true} noStyle>
                  <FormInput
                    col
                    xs={6}
                    name={getName('ctecalculationtype', cteid)}
                    comcode="ctecalculationtype"
                  >
                    <ParListSelect parcode="CALMETHOD" />
                  </FormInput>
                </Form.Item>

                <FormInput
                  col
                  xs={12}
                  name={getName('ctedescription', cteid)}
                  comcode="ctedescription"
                >
                  <Input />
                </FormInput>
              </Row>
              <Row gutter={20}>
                <FormInput
                  col
                  xs={6}
                  name={getName('ctestartdate', cteid)}
                  comcode="ctestartdate"
                >
                  <DatePicker />
                </FormInput>
                {/* onChange={() => debouncedCalculateNew()} */}
                <FormInput
                  col
                  xs={6}
                  name={getName('cteenddate', cteid)}
                  comcode="cteenddate"
                >
                  <DatePicker />
                </FormInput>

                <Form.Item shouldUpdate={() => true} noStyle>
                  {({ getFieldValue }) => (
                    <FormInput
                      col
                      xs={6}
                      name={getName('taxcode', cteid)}
                      comcode="taxcode"
                    >
                      <TaxSelect taxflow="INOUT" />
                    </FormInput>
                  )}
                </Form.Item>

                <Form.Item shouldUpdate={() => true} noStyle>
                  {({ getFieldValue }) => (
                    <FormInput
                      col
                      xs={6}
                      name={getName('currcode', cteid)}
                      comcode="currcode"
                    >
                      <ParListSelect parcode="CURRENCY" />
                    </FormInput>
                  )}
                </Form.Item>
              </Row>

              <Row gutter={20}>
                <FormInput
                  col
                  xs={6}
                  name={getName('ctefinancedamount', cteid)}
                  comcode="ctefinancedamount"
                >
                  <InputCurrency currcode={form.getFieldValue('currcode')} />
                </FormInput>

                <FormInput
                  col
                  xs={6}
                  name={getName('ctervamount', cteid)}
                  comcode="ctervamount"
                >
                  <InputCurrency currcode={form.getFieldValue('currcode')} />
                </FormInput>

                <FormInput
                  col
                  xs={6}
                  name={getName('ctestatuslabel', cteid)}
                  comcode="ctestatuslabel"
                >
                  <Value />
                </FormInput>


                <FormInput
                  col
                  xs={6}
                  name={getName('cteduration', cteid)}
                  comcode="cteduration"
                >
                  <Value />
                </FormInput>
              </Row>
            </Card>
            <Card
              bordered
              title={<Title level={4} comcode="tabPrefin"></Title>}
            >
              <Row gutter={20}>
                <Col span={6}>
                  <Form.Item shouldUpdate={() => true} noStyle>
                    {({ getFieldValue }) => (
                      <FormInput
                        col
                        xs={24}
                        name={getName('prefinmethod', cteid)}
                      >
                        <ParListSelect
                          parcode="PREFINMET"
                          // parvalueparent={getFieldValue('prefinmethod')}
                        />
                      </FormInput>
                    )}
                  </Form.Item>
                </Col>

                <Col span={6}>
                  <Form.Item shouldUpdate={() => true} noStyle>
                    {({ getFieldValue }) => (
                      <FormInput
                        col
                        xs={24}
                        name={getName('prefinbasis', cteid)}
                        comcode="prefinbasis"
                      >
                        <ParListSelect parcode="PREFINBAS" />
                      </FormInput>
                    )}
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item shouldUpdate={() => true} noStyle>
                    {({ getFieldValue }) => (
                      <FormInput
                        col
                        xs={24}
                        name={getName('prefinperiodicity', cteid)}
                        comcode="prefinperiodicity"
                      >
                        <ParListSelect
                          parcode="PREFINPER"
                          // parvalueparent={getFieldValue('prefinperiodicity')}
                        />
                      </FormInput>
                    )}
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={20}>
                <Col span={6}>
                  <Form.Item shouldUpdate={() => true} noStyle>
                    {({ getFieldValue }) => (
                      <FormInput
                        col
                        xs={24}
                        name={getName('prefinratetype', cteid)}
                        comcode="prefinratetype"
                      >
                        <ParListSelect parcode="RATETYPE" />
                      </FormInput>
                    )}
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item shouldUpdate={() => true} noStyle>
                    {({ getFieldValue }) => {
                      return (
                        <FormInput
                          col
                          xs={24}
                          name={getName('prefinrateformula', cteid)}
                          comcode="prefinrateformula"
                        >
                          <RateFormulaSelect
                            params={{
                              formulatype: getFieldValue(
                                getName('prefinratetype', cteid)
                              ),
                            }}
                            onSelected={(val) => {
                              handleselectformula(val?.ratevalue, 'prefin');
                              //   debouncedCalculateNew();
                            }}
                          />
                        </FormInput>
                      );
                    }}
                  </Form.Item>
                </Col>
                <Col span={3}>
                  <FormItem shouldUpdate>
                    {({ getFieldValue }) => {
                      return (
                        <FormInput
                          col
                          xs={24}
                          name={getName('prefinrateref', cteid)}
                          comcode="prefinrateref"
                        >
                          <Value
                            formatter={() =>
                              toRate(
                                getFieldValue(
                                  getName('prefinrateref', cteid)
                                ) as any
                              )
                            }
                          />
                        </FormInput>
                      );
                    }}
                  </FormItem>
                </Col>
                <Col span={3}>
                  <FormInput
                    col
                    xs={24}
                    name={getName('prefinratespread', cteid)}
                    comcode="prefinratespread"
                  >
                    <InputRate
                      onChange={(val) => {
                        handleratespread(val, 'prefin');
                        // debouncedCalculateNew();
                      }}
                    />
                  </FormInput>
                </Col>

                <Col span={3}>
                  <FormItem shouldUpdate>
                    {({ getFieldValue }) => {
                      return (
                        <FormInput
                          col
                          xs={24}
                          name={getName('prefinnominalrate', cteid)}
                          comcode="prefinnominalrate"
                        >
                          <InputRate
                            value={getFieldValue(
                              getName('prefinnominalrate', cteid)
                            )}
                          />
                        </FormInput>
                      );
                    }}
                  </FormItem>
                </Col>
              </Row>

              <Row gutter={20}>
                <FormInput
                  col
                  xs={6}
                  name={getName('payrefrence', cteid)}
                  comcode="payrefrence"
                >
                  <ModalControllerNV
                    content={({ setVisible, visible }) => (
                      <a onClick={() => setVisible(true)}>
                        {form.getFieldValue(getName('payrefrence', cteid))}
                      </a>
                    )}
                    modal={({ setVisible, visible }) => (
                      <PayementModal
                        payid={form.getFieldValue(getName('payid', cteid))}
                        showAsModal
                        hideButtons
                        visible={visible}
                        onCancel={() => setVisible(false)}
                        onSuccess={() => setVisible(false)}
                      />
                    )}
                  />
                </FormInput>

                <FormInput
                  col
                  xs={6}
                  name={getName('payreimbreference', cteid)}
                  comcode="payreimbreference"
                >
                  <ModalControllerNV
                    content={({ setVisible, visible }) => (
                      <a onClick={() => setVisible(true)}>
                        {form.getFieldValue(
                          getName('payreimbreference', cteid)
                        )}
                      </a>
                    )}
                    modal={({ setVisible, visible }) => (
                      <PayementModal
                        payid={form.getFieldValue(
                          getName('payidreimbursment', cteid)
                        )}
                        showAsModal
                        hideButtons
                        visible={visible}
                        onCancel={() => setVisible(false)}
                        onSuccess={() => setVisible(false)}
                      />
                    )}
                  />
                </FormInput>
              </Row>
            </Card>
          </TabPane>
          {!preFin && (
            <>
              {' '}
              <TabPane tab={<GetLabel label="tabFinCondition" />} key={24}>
                <Card bordered type="inner" style={{ height: '100%' }}>
                  <Row gutter={20}>
                    <Form.Item
                      shouldUpdate={shouldUpdateCompare('currcode')}
                      noStyle
                    >
                      {({ getFieldValue }) => {
                        return (
                          <InputCurrency
                            col
                            md={12}
                            currcode={getFieldValue('currcode')}
                            // onChange={() => debouncedCalculateNew()}
                            comcode="cteupfrontamount"
                            fieldname={getName('cteupfrontamount', cteid)}
                          />
                        );
                      }}
                    </Form.Item>
                    <Form.Item shouldUpdate={() => true} noStyle>
                      {({ getFieldValue }) => {
                        const investamount = isNaN(
                          getFieldValue(getName('cteinvestamount', cteid))
                        )
                          ? 0
                          : getFieldValue(getName('cteinvestamount', cteid));

                        const cteupfrontamount = isNaN(
                          getFieldValue(getName('cteupfrontamount', cteid))
                        )
                          ? 0
                          : getFieldValue(getName('cteupfrontamount', cteid));

                        const ctepartmethod = getFieldValue(
                          getName('ctepartmethod', cteid)
                        );

                        var ctepartamount = 0;
                        if (
                          ctepartmethod === 'PROMO' ||
                          ctepartmethod === 'REDUCEFIN'
                        ) {
                          ctepartamount = isNaN(
                            getFieldValue(getName('ctepartamount', cteid))
                          )
                            ? 0
                            : getFieldValue(getName('ctepartamount', cteid));
                        }

                        const finamount =
                          investamount - cteupfrontamount - ctepartamount;

                        //

                        return (
                          <FormInput
                            style={{ color: 'red' }}
                            col
                            xs={24}
                            md={6}
                            name={getName('ctefinancedamount', cteid)}
                            comcode="ctefinancedamount"
                          >
                            <Text>
                              {toCurrency(finamount, getFieldValue('currcode'))}
                            </Text>
                          </FormInput>
                        );
                      }}
                    </Form.Item>
                    <FormInput
                      style={{ color: 'red' }}
                      col
                      xs={24}
                      md={6}
                      name={getName('ctegraceperiodmethod', cteid)}
                      comcode="ctegraceperiodmethod"
                    >
                      <ParListSelect parcode="GPMETHOD" />
                    </FormInput>

                    <Form.Item shouldUpdate={() => true} noStyle>
                      {({ getFieldValue }) => {
                        return (
                          <FormInput
                            col
                            xs={24}
                            md={12}
                            name={getName('ctebilligdate', cteid)}
                          >
                            <ParListSelect
                              parcode="BILLDATE"
                              offerid={getFieldValue('offerid')}
                              //   onChange={() => debouncedCalculateNew()}
                            />
                          </FormInput>
                        );
                      }}
                    </Form.Item>

                    <FormInput
                      col
                      xs={24}
                      md={12}
                      comcode="ctinitstartdate"
                      name={getName('ctestartdate', cteid)}
                      //name="ctrequestdate"
                    >
                      <DatePicker
                        style={{ width: '100%' }}
                        defaultValue={moment(new Date(), 'YYYY-MM-DD')}
                        // onChange={() => debouncedCalculateNew()}
                      />
                    </FormInput>
                    <Form.Item shouldUpdate={() => true} noStyle>
                      {({ getFieldValue }) => {
                        return (
                          <FormInput
                            col
                            xs={24}
                            md={12}
                            comcode="ctedeferredinterestmethod"
                            name={getName('ctedeferredinterestmethod', cteid)}
                          >
                            <ParListSelect
                              parcode="CTEDEFINT"
                              offerid={getFieldValue('offerid')}
                              //   onChange={() => debouncedCalculateNew()}
                            />
                          </FormInput>
                        );
                      }}
                    </Form.Item>

                    <FormInput
                      col
                      xs={24}
                      md={6}
                      comcode="ctedeferredinterestnominalrate"
                      name={getName('ctedeferredinterestnominalrate', cteid)}
                    >
                      <InputRate
                        style={{ width: '100%' }}
                        // onChange={() => debouncedCalculateNew()}
                      />
                    </FormInput>
                    <Form.Item
                      shouldUpdate={shouldUpdateCompare('currcode')}
                      noStyle
                    >
                      {({ getFieldValue }) => {
                        return (
                          <FormInput
                            col
                            xs={24}
                            md={6}
                            style={{ color: 'red' }}
                            name={getName('ctedeferredinterest', cteid)}
                            comcode="ctedeferredinterest"
                          >
                            <Value
                              formatter={(value) =>
                                toCurrency(value, getFieldValue('currcode'))
                              }
                            ></Value>
                          </FormInput>
                        );
                      }}
                    </Form.Item>
                    <Form.Item shouldUpdate={() => true} noStyle>
                      {({ getFieldValue }) => {
                        return (
                          <FormInput
                            col
                            xs={24}
                            md={12}
                            name={getName('ctedepositinterestmethod', cteid)}
                            comcode="ctedepositinterestmethod"
                          >
                            <ParListSelect
                              parcode="CTEDEPOINT"
                              offerid={getFieldValue('offerid')}
                              //   onChange={() => debouncedCalculateNew()}
                            />
                          </FormInput>
                        );
                      }}
                    </Form.Item>

                    <FormInput
                      col
                      xs={24}
                      md={6}
                      comcode="ctedepositnominalrate"
                      name={getName('ctedepositnominalrate', cteid)}
                    >
                      <InputRate
                        style={{ width: '100%' }}
                        // onChange={() => debouncedCalculateNew()}
                      />
                    </FormInput>
                    <Form.Item
                      shouldUpdate={shouldUpdateCompare('currcode')}
                      noStyle
                    >
                      {({ getFieldValue }) => {
                        return (
                          <FormInput
                            style={{ color: 'red' }}
                            col
                            xs={24}
                            md={6}
                            name={getName('ctedepositinterest', cteid)}
                            //name='ctedepositinterest'
                            comcode="ctedepositinterest"
                          >
                            <Value
                              formatter={(value) =>
                                toCurrency(value, getFieldValue('currcode'))
                              }
                            ></Value>
                          </FormInput>
                        );
                      }}
                    </Form.Item>
                    <Form.Item shouldUpdate={() => true} noStyle>
                      {({ getFieldValue }) => (
                        <FormInput
                          col
                          xs={24}
                          md={24}
                          comcode="ctedepositamount"
                          name={getName('ctedepositamount', cteid)}
                        >
                          <SliderWithInputAndPercentage
                            currcode={getFieldValue('currcode')}
                            max={getFieldValue(
                              getName(
                                'ctedepositcoef',
                                cteid
                              )
                            )}
                            min={0}
                            basis={getFieldValue(
                              getName('cteinvestamount', cteid)
                            )}
                            step={1}
                            precisionAmount={2}
                            precisionCoef={5}
                            // onChange={() => debouncedCalculateNew()}
                          />
                        </FormInput>
                      )}
                    </Form.Item>

                    <Form.Item shouldUpdate={() => true} noStyle>
                      {({ getFieldValue }) => {
                        return (
                          <FormInput
                            col
                            xs={24}
                            md={12}
                            name={getName('ctepartmethod', cteid)}
                            comcode="ctepartmethod"
                          >
                            <ParListSelect
                              parcode="CTEPARTMET"
                              offerid={getFieldValue('offerid')}
                              //   onChange={() => debouncedCalculateNew()}
                            />
                          </FormInput>
                        );
                      }}
                    </Form.Item>
                    <Form.Item
                      shouldUpdate={shouldUpdateCompare('currcode')}
                      noStyle
                    >
                      {({ getFieldValue }) => {
                        return (
                          <InputCurrency
                            col
                            md={6}
                            currcode={getFieldValue('currcode')}
                            comcode="ctepartamount"
                            // onChange={() => debouncedCalculateNew()}
                            fieldname={getName('ctepartamount', cteid)}
                          />
                        );
                      }}
                    </Form.Item>
                    <FormInput
                      col
                      xs={24}
                      md={6}
                      comcode="ctepartrate"
                      name={getName('ctepartrate', cteid)}
                    >
                      <InputRate
                        style={{ width: '100%' }}
                        // onChange={() => debouncedCalculateNew()}
                      />
                    </FormInput>
                  </Row>
                </Card>
              </TabPane>
              <TabPane tab={<GetLabel label="tabPayment" />} key={25}>
                <Card bordered title={<Title level={4} comcode="Rate"></Title>}>
                  <Row gutter={20}>
                    <Form.Item shouldUpdate={() => true} noStyle>
                      <FormInput
                        col
                        xs={6}
                        name={getName('cteratetype', cteid)}
                        comcode="cteratetype"
                      >
                        <ParListSelect parcode="RATETYPE" />
                      </FormInput>
                    </Form.Item>
                    <Form.Item shouldUpdate={() => true} noStyle>
                      {({ getFieldValue }) => {
                        return (
                          <FormInput
                            col
                            xs={6}
                            name={getName('cterateformula', cteid)}
                            comcode="cterateformula"
                          >
                            <RateFormulaSelect
                              params={{
                                formulatype: getFieldValue(
                                  getName('cteratetype', cteid)
                                ),
                              }}
                              onSelected={(val) => {
                                handleselectformula(val?.ratevalue, 'cte');
                                // debouncedCalculateNew();
                              }}
                            />
                          </FormInput>
                        );
                      }}
                    </Form.Item>
                    <Form.Item shouldUpdate={() => true} noStyle>
                      <FormInput
                        col
                        xs={6}
                        name={getName('cterateperiodicity', cteid)}
                        comcode="cterateperiodicity"
                      >
                        <ParListSelect parcode="PERIOD" />
                      </FormInput>
                    </Form.Item>
                    <FormInput
                      col
                      xs={3}
                      comcode="cterateref"
                      name={getName('cterateref', cteid)}
                    >
                      <Value formatter={toRate} />
                    </FormInput>

                    <FormInput
                      col
                      xs={3}
                      comcode="cteratespread"
                      name={getName('cteratespread', cteid)}
                    >
                      <Value formatter={toRate} />
                    </FormInput>

                    <Form.Item shouldUpdate={() => true} noStyle>
                      {({ getFieldValue }) => {
                        return (
                          <FormInput
                            col
                            xs={6}
                            comcode="cteinterestmethod"
                            name={getName('cteinterestmethod', cteid)}
                          >
                            <ParListSelect
                              parcode="INTCALC"
                              // parvalueparent={getFieldValue('"cteinterestmethod"')}
                            />
                          </FormInput>
                        );
                      }}
                    </Form.Item>

                    <Form.Item shouldUpdate={() => true} noStyle>
                      {({ getFieldValue }) => {
                        return (
                          <FormInput
                            col
                            xs={6}
                            comcode="cteratebasis"
                            name={getName('cteratebasis', cteid)}
                          >
                            <ParListSelect
                              parcode="CALBASIS"
                              // parvalueparent={getFieldValue('"cteratebasis"')}
                            />
                          </FormInput>
                        );
                      }}
                    </Form.Item>

                    <Form.Item shouldUpdate={() => true} noStyle>
                      {({ getFieldValue }) => (
                        <FormInput
                          col
                          xs={12}
                          comcode="ctenominalrate"
                          name={getName('ctenominalrate', cteid)}
                        >
                          <SliderWithInput
                            max={getFieldValue(getHelper('ratemax', cteid))}
                            min={getFieldValue(getHelper('ratemin', cteid))}
                            step={0.001}
                            precision={5}
                            widthInput={5}
                            // onChange={() => debouncedCalculateNew()}
                          />
                        </FormInput>
                      )}
                    </Form.Item>

                    <FormInput
                      col
                      xs={6}
                      name={getName('cteactuarialrate', cteid)}
                      comcode="cteactuarialrate"
                    >
                      <InputRate style={{ width: '100%' }} disabled />
                    </FormInput>
                  </Row>
                </Card>
                <Form.Item shouldUpdate noStyle>
                  {({ getFieldValue }) => {
                    const calcmethod = getFieldValue(
                      getName('ctecalculationtype', cteid)
                    );
                    const steps =
                      getFieldValue(getName('conElemSteps', cteid)) ?? [];

                    if (
                      calcmethod === 'LINEAR' ||
                      calcmethod === 'FIXEDAMORT'
                    ) {
                      return (
                        <Card
                          bordered
                          title={
                            <Title level={4} comcode="LinearPayment"></Title>
                          }
                        >
                          <Row gutter={20}>
                            <Form.Item shouldUpdate={() => true} noStyle>
                              {({ getFieldValue }) => {
                                return (
                                  <FormInput
                                    col
                                    xs={6}
                                    name={getName('cteperiodicity', cteid)}
                                  >
                                    <ParListSelect
                                      parcode="PERIOD"
                                      // parvalueparent={getFieldValue('"cteperiodicity"')}
                                    />
                                  </FormInput>
                                );
                              }}
                            </Form.Item>
                            <Form.Item shouldUpdate={() => true} noStyle>
                              <FormInput
                                col
                                xs={6}
                                name={getName('cteunit', cteid)}
                              >
                                <ParListSelect
                                  parcode="UNIT"
                                  // parvalueparent={getFieldValue('cteunit')}
                                />
                              </FormInput>
                            </Form.Item>
                            <Form.Item shouldUpdate={() => true} noStyle>
                              <FormInput
                                col
                                xs={6}
                                name={getName('ctepaymentterm', cteid)}
                              >
                                <ParListSelect
                                  parcode="TERM"
                                  // parvalueparent={getFieldValue('ctepaymentterm')}
                                />
                              </FormInput>
                            </Form.Item>
                          </Row>
                          <Row gutter={[8, 0]}>
                            <Form.Item shouldUpdate={() => true} noStyle>
                              {({ getFieldValue }) => (
                                <FormInput
                                  col
                                  xs={12}
                                  comcode="cteduration"
                                  name={getName('cteduration', cteid)}
                                >
                                  <SliderWithInput
                                    max={getFieldValue(
                                      getHelper('durationmax', cteid)
                                    )}
                                    min={getFieldValue(
                                      getHelper('durationmin', cteid)
                                    )}
                                    precision={0}
                                    // onChange={() => debouncedCalculateNew()}
                                  />
                                </FormInput>
                              )}
                            </Form.Item>
                            <Form.Item shouldUpdate={() => true} noStyle>
                              {({ getFieldValue }) => (
                                <FormInput
                                  col
                                  xs={12}
                                  comcode="ctegraceperiodduration"
                                  name={getName(
                                    'ctegraceperiodduration',
                                    cteid
                                  )}
                                >
                                  <SliderWithInput
                                    max={getFieldValue(
                                      getHelper('gpdurationmax', cteid)
                                    )}
                                    min={0}
                                    precision={0}
                                    // onChange={() => debouncedCalculateNew()}
                                  />
                                </FormInput>
                              )}
                            </Form.Item>
                          </Row>
                          <Row gutter={20}>
                            <Form.Item shouldUpdate={() => true} noStyle>
                              {({ getFieldValue }) => (
                                <FormInput
                                  col
                                  xs={12}
                                  comcode="ctefirstpayment"
                                  name={getName('ctefirstpayment', cteid)}
                                >
                                  <SliderWithInputAndPercentage
                                    currcode={getFieldValue('currcode')}
                                    max={getFieldValue(
                                      getHelper('frmax', cteid)
                                    )}
                                    min={getFieldValue(
                                      getHelper('frmin', cteid)
                                    )}
                                    defaultValue={100} //getFieldValue(['helpers', 'frdefault'])*getFieldValue('cteinvestamount')/100}
                                    value={100} //{getFieldValue(['helpers', 'frdefault'])*getFieldValue('cteinvestamount')/100}
                                    basis={getFieldValue(
                                      getName('cteinvestamount', cteid)
                                    )}
                                    step={1}
                                    precisionAmount={2}
                                    precisionCoef={5}
                                    // onChange={() => debouncedCalculateNew()}
                                  />
                                </FormInput>
                              )}
                            </Form.Item>
                            <Form.Item shouldUpdate={() => true} noStyle>
                              {({ getFieldValue }) => (
                                <FormInput
                                  col
                                  xs={12}
                                  comcode="ctervamount"
                                  name={getName('ctervamount', cteid)}
                                >
                                  <SliderWithInputAndPercentage
                                    currcode={getFieldValue('currcode')}
                                    max={getFieldValue(
                                      getHelper('rvmax', cteid)
                                    )}
                                    min={getFieldValue(
                                      getHelper('rvmin', cteid)
                                    )}
                                    basis={getFieldValue(
                                      getName('cteinvestamount', cteid)
                                    )}
                                    step={1}
                                    precisionAmount={2}
                                    precisionCoef={5}
                                    // onChange={() => debouncedCalculateNew()}
                                  />
                                </FormInput>
                              )}
                            </Form.Item>
                          </Row>
                          <Row gutter={[8, 0]}>
                            <FormInput
                              style={{ color: 'blue' }}
                              col
                              xs={6}
                              comcode="cteinstallmentamount"
                              name={getName('cteinstallmentamount', cteid)}
                            >
                              <Value
                                formatter={(value) =>
                                  toCurrency(value, getFieldValue('currcode'))
                                }
                              ></Value>
                            </FormInput>
                            <FormInput
                              style={{ color: 'green' }}
                              col
                              xs={6}
                              comcode="ctedepositinterest"
                              name={getName('ctedepositinterest', cteid)}
                            >
                              <Value
                                formatter={(value) =>
                                  toCurrency(value, getFieldValue('currcode'))
                                }
                              ></Value>
                            </FormInput>
                            <FormInput
                              style={{ color: 'red' }}
                              col
                              xs={6}
                              name={getName('cterentalamount', cteid)}
                              comcode="cterentalamount"
                            >
                              <Value
                                formatter={(value) =>
                                  toCurrency(value, getFieldValue('currcode'))
                                }
                              ></Value>
                            </FormInput>
                          </Row>
                        </Card>
                      );
                    } else {
                      if (calcmethod === 'STEP') {
                        return (
                          <Card
                            bordered
                            title={
                              <Title level={4} comcode="StepPayment"></Title>
                            }
                          >
                            <Row gutter={20}>
                              <Col span={12}>
                                <Form.Item shouldUpdate={() => true} noStyle>
                                  <FormInput
                                    col
                                    xs={6}
                                    name={getName('ctepaymentterm', cteid)}
                                  >
                                    <ParListSelect
                                      parcode="TERM"
                                      // parvalueparent={getFieldValue('ctepaymentterm')}
                                    />
                                  </FormInput>
                                </Form.Item>
                              </Col>
                              <Col span={4} />
                              <Col span={4} style={{ textAlign: 'left' }}>
                                <Form.Item shouldUpdate={() => true} noStyle>
                                  {({ getFieldValue }) => (
                                    <FinancialScheduleModal
                                      finElement={form
                                        .getFieldValue(['elements', 'FIN'])
                                        ?.find(
                                          (ele: any) =>
                                            ele.cteid ===
                                            form.getFieldValue(
                                              'selectedElement'
                                            )
                                        )}
                                      comcode="finSchedule"
                                      controller={
                                        <ScheduleButton
                                          size="large"
                                          //   onClickCapture={
                                          //     calculatePaymentSheduleSteps
                                          //   }
                                          comcode="finSchedule"
                                          twoToneColor={
                                            form.getFieldValue(
                                              getName('elementstatus', cteid)
                                            ) === 'ERROR'
                                              ? 'red'
                                              : 'blue'
                                          }
                                        ></ScheduleButton>
                                      }
                                    />
                                  )}
                                </Form.Item>
                              </Col>

                              <Col span={4}>
                                <NewButtonSmall
                                  type="primary"
                                  //   onClick={addStep}
                                  comcode="add"
                                />
                              </Col>
                            </Row>
                            <Row gutter={20}>
                              <DataGrid
                                rowKey="ctesid"
                                dataSource={[...steps]}
                                // columns={columns}
                                columns={[]}
                              />
                            </Row>
                          </Card>
                        );
                      } else {
                        if (calcmethod === 'STEPWEIGH') {
                          return (
                            <Card
                              bordered
                              title={
                                <Title
                                  level={4}
                                  comcode="WeightedStepPayment"
                                ></Title>
                              }
                            >
                              <Row>
                                <Col span={11}>
                                  <Form.Item shouldUpdate={() => true} noStyle>
                                    {({ getFieldValue }) => (
                                      <FormInput
                                        col
                                        xs={22}
                                        comcode="cteduration"
                                        name={getName('cteduration', cteid)}
                                      >
                                        <SliderWithInput
                                          max={getFieldValue(
                                            getHelper('durationmax', cteid)
                                          )}
                                          min={getFieldValue(
                                            getHelper('durationmin', cteid)
                                          )}
                                          precision={0}
                                          //   onChange={() => debouncedCalculateNew()}
                                        />
                                      </FormInput>
                                    )}
                                  </Form.Item>
                                </Col>
                                <Col span={11}>
                                  <Form.Item shouldUpdate={() => true} noStyle>
                                    {({ getFieldValue }) => (
                                      <FormInput
                                        col
                                        xs={22}
                                        comcode="ctervamount"
                                        name={getName('ctervamount', cteid)}
                                      >
                                        <SliderWithInputAndPercentage
                                          currcode={getFieldValue('currcode')}
                                          max={getFieldValue(
                                            getHelper('rvmax', cteid)
                                          )}
                                          min={getFieldValue(
                                            getHelper('rvmin', cteid)
                                          )}
                                          basis={getFieldValue(
                                            getName('cteinvestamount', cteid)
                                          )}
                                          step={1}
                                          precisionAmount={2}
                                          precisionCoef={5}
                                          //   onChange={() => debouncedCalculateNew()}
                                        />
                                      </FormInput>
                                    )}
                                  </Form.Item>
                                </Col>

                                <Col span={2}>
                                  <NewButtonSmall
                                    type="primary"
                                    // onClick={addWeightedStep}
                                    comcode="add"
                                  />

                                  {/* <Button
                        size="small"
                        icon={
                          <CalculatorTwoTone
                            twoToneColor={
                              form.getFieldValue(
                                getName('elementstatus', cteid)
                              ) === 'ERROR'
                                ? 'red'
                                : 'green'
                            }
                          />
                        }
                        onClick={
                          calculatePaymentSheduleWeightedStep
                        }
                      />  */}
                                  <br />
                                  <br />
                                  <Form.Item shouldUpdate={() => true} noStyle>
                                    {({ getFieldValue }) => (
                                      <FinancialScheduleModal
                                        finElement={form
                                          .getFieldValue(['elements', 'FIN'])
                                          ?.find(
                                            (ele: any) =>
                                              ele.cteid ===
                                              form.getFieldValue(
                                                'selectedElement'
                                              )
                                          )}
                                        comcode="finSchedule"
                                        controller={
                                          <ScheduleButton
                                            // onClickCapture={(e) =>
                                            //   calculatePaymentSheduleWeightedStep(
                                            //     getFieldValue(
                                            //       getName(
                                            //         'ctecalculationtype',
                                            //         cteid
                                            //       )
                                            //     ),
                                            //     getFieldValue(
                                            //       getName('conElemSteps', cteid)
                                            //     )
                                            //   )
                                            // }
                                            size="large"
                                            comcode="finSchedule"
                                            twoToneColor="blue"
                                          ></ScheduleButton>
                                        }
                                      />
                                    )}
                                  </Form.Item>
                                </Col>
                              </Row>
                              <Row gutter={[8, 0]}>
                                <FormInput
                                  style={{ color: 'blue' }}
                                  col
                                  xs={6}
                                  comcode="cteinstallmentamount"
                                  name={getName('cteinstallmentamount', cteid)}
                                >
                                  <Value
                                    formatter={(value) =>
                                      toCurrency(
                                        value,
                                        getFieldValue('currcode')
                                      )
                                    }
                                  ></Value>
                                </FormInput>
                                <FormInput
                                  style={{ color: 'green' }}
                                  col
                                  xs={6}
                                  comcode="ctedepositinterest"
                                  name={getName('ctedepositinterest', cteid)}
                                >
                                  <Value
                                    formatter={(value) =>
                                      toCurrency(
                                        value,
                                        getFieldValue('currcode')
                                      )
                                    }
                                  ></Value>
                                </FormInput>
                                <FormInput
                                  style={{ color: 'red' }}
                                  col
                                  xs={6}
                                  name={getName('cterentalamount', cteid)}
                                  comcode="cterentalamount"
                                >
                                  <Value
                                    formatter={(value) =>
                                      toCurrency(
                                        value,
                                        getFieldValue('currcode')
                                      )
                                    }
                                  ></Value>
                                </FormInput>
                              </Row>
                              <Row gutter={20}>
                                <DataGrid
                                  rowKey="ctesid"
                                  dataSource={[...steps]}
                                  //   columns={columnsWeigthedStep}
                                  columns={[]}
                                />
                              </Row>
                            </Card>
                          );
                        }
                        return (
                          <Card
                            bordered
                            title={
                              <Title
                                level={4}
                                comcode="SeasonalPayment"
                              ></Title>
                            }
                          >
                            <Row>
                              <Col span={12}>
                                <Form.Item shouldUpdate={() => true} noStyle>
                                  <FormInput
                                    col
                                    xs={6}
                                    name={getName('ctepaymentterm', cteid)}
                                  >
                                    <ParListSelect
                                      parcode="TERM"
                                      // parvalueparent={getFieldValue('ctepaymentterm')}
                                    />
                                  </FormInput>
                                </Form.Item>
                                <Form.Item shouldUpdate={() => true} noStyle>
                                  {({ getFieldValue }) => (
                                    <FormInput
                                      col
                                      xs={15}
                                      comcode="cteduration"
                                      name={getName('cteduration', cteid)}
                                    >
                                      <SliderWithInput
                                        max={getFieldValue(
                                          getHelper('durationmax', cteid)
                                        )}
                                        min={getFieldValue(
                                          getHelper('durationmin', cteid)
                                        )}
                                        precision={0}
                                        // onChange={() => debouncedCalculateNew()}
                                      />
                                    </FormInput>
                                  )}
                                </Form.Item>

                                <Form.Item shouldUpdate={() => true} noStyle>
                                  {({ getFieldValue }) => (
                                    <FormInput
                                      col
                                      xs={15}
                                      comcode="ctervamount"
                                      name={getName('ctervamount', cteid)}
                                    >
                                      <SliderWithInputAndPercentage
                                        currcode={getFieldValue('currcode')}
                                        max={getFieldValue(
                                          getHelper('rvmax', cteid)
                                        )}
                                        min={getFieldValue(
                                          getHelper('rvmin', cteid)
                                        )}
                                        basis={getFieldValue(
                                          getName('cteinvestamount', cteid)
                                        )}
                                        step={1}
                                        precisionAmount={2}
                                        precisionCoef={5}
                                        // onChange={() => debouncedCalculateNew()}
                                      />
                                    </FormInput>
                                  )}
                                </Form.Item>
                              </Col>
                              <Col span={12}>
                                <Row>
                                  <Col span={6}>
                                    <Button
                                      size="small"
                                      icon={
                                        <CalculatorTwoTone
                                          twoToneColor={
                                            form.getFieldValue(
                                              getName('elementstatus', cteid)
                                            ) === 'ERROR'
                                              ? 'red'
                                              : 'green'
                                          }
                                        />
                                      }
                                      //   onClick={calculateSeasonal}
                                    />
                                  </Col>
                                  <Col span={12} style={{ textAlign: 'left' }}>
                                    <Form.Item
                                      shouldUpdate={() => true}
                                      noStyle
                                    >
                                      {({ getFieldValue }) => (
                                        <FinancialScheduleModal
                                          finElement={form
                                            .getFieldValue(['elements', 'FIN'])
                                            ?.find(
                                              (ele: any) =>
                                                ele.cteid ===
                                                form.getFieldValue(
                                                  'selectedElement'
                                                )
                                            )}
                                          comcode="finSchedule"
                                          controller={
                                            <ScheduleButton
                                              size="large"
                                              comcode="finSchedule"
                                              twoToneColor="blue"
                                            ></ScheduleButton>
                                          }
                                        />
                                      )}
                                    </Form.Item>
                                  </Col>

                                  <Col span={6}>
                                    <NewButtonSmall
                                      type="primary"
                                      //   onClick={addStep}
                                      comcode="add"
                                    />
                                  </Col>
                                </Row>

                                <Row>
                                  <Col span={24}>
                                    <Form.Item
                                      shouldUpdate={() => true}
                                      noStyle
                                    >
                                      {({ getFieldValue }) => (
                                        <FormInput
                                          col
                                          xs={24}
                                          md={24}
                                          comcode="ctefirstpayment"
                                          name={getName(
                                            'ctefirstpayment',
                                            cteid
                                          )}
                                        >
                                          <SliderWithInputAndPercentage
                                            currcode={getFieldValue('currcode')}
                                            max={getFieldValue(
                                              getHelper('frmax', cteid)
                                            )}
                                            min={getFieldValue(
                                              getHelper('frmin', cteid)
                                            )}
                                            defaultValue={100} //getFieldValue(['helpers', 'frdefault'])*getFieldValue('cteinvestamount')/100}
                                            value={100} //{getFieldValue(['helpers', 'frdefault'])*getFieldValue('cteinvestamount')/100}
                                            basis={getFieldValue(
                                              getName('cteinvestamount', cteid)
                                            )}
                                            step={1}
                                            precisionAmount={2}
                                            precisionCoef={5}
                                            // onChange={() => debouncedCalculateNew()}
                                          />
                                        </FormInput>
                                      )}
                                    </Form.Item>
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                            <Row gutter={20}>
                              <DataGrid
                                rowKey="ctesid"
                                dataSource={[...steps]}
                                // columns={columnsSeasonal}
                                columns={[]}
                              />
                            </Row>
                          </Card>
                        );
                      }
                    }
                  }}
                </Form.Item>
              </TabPane>
            </>
          )}
        </Tabs>
      </Card>
    </Modal>)
  );
};

export default AdvancedModeModal;
